
const mapUtility = {
    mapCornersDaytona:{
        topLeft: { lat: 29.1898381, lng: -81.0587411 },
        topRight: { lat: 29.1755440, lng: -81.0703218 },
        bottomLeft: { lat: 29.1957086, lng: -81.0682795 },
        bottomRight: { lat: 29.1813532, lng: -81.0799433 },
        width: 468,
        height: 275,
        image: "",
        class: "map-daytona"
    },
    mapCornersNH: {
        topLeft: { lat: 43.366051, lng: -71.465769 },
        topRight: { lat: 43.366040, lng: -71.455493 },
        bottomLeft: { lat: 43.35909444289533, lng: -71.46572534128865 },
        bottomRight: { lat: 43.35907761885815, lng: -71.45531483502396 },
        width: 468,
        height: 433,
        image: "",
        class: "map-nh"
    },
    mapCornersCoronado: {
        topLeft: {lat: 32.718834, lng:-117.217419},
        topRight: {lat: 32.718834, lng:-117.181914},
        bottomLeft: {lat: 32.699387, lng:-117.217328},
        bottomRight: {lat: 32.699425, lng:-117.181868},
        width: 480,
        height: 313,
        class: "map-coronado"
    },
    mapCornersSonoma: {
        topLeft: {lat: 38.168652, lng:-122.465654},
        topRight: {lat: 38.165805, lng:-122.447013},
        bottomLeft: {lat: 38.159341, lng:-122.467903},
        bottomRight: {lat: 38.156536, lng:-122.449351},
        width: 480,
        height: 306,
        class: "map-sonoma"
    },
    mapCornersCurrent: null,
    init(){
        this.mapCornersCurrent = this.mapCornersDaytona;
    },
    gpsToPixel(lat, lng, corners, imageWidth, imageHeight) {
        const { topLeft, topRight, bottomLeft, bottomRight } = corners;

        // Solve for (u, v) in [0,1]x[0,1] using bilinear inverse mapping.
        // A point P on a bilinear patch is:
        //   P(u,v) = (1-u)(1-v)*TL + u(1-v)*TR + (1-u)v*BL + u*v*BR
        // We solve for u,v given P = (lat, lng).

        function bilinearPoint(u, v) {
            return {
                lat:
                    (1 - u) * (1 - v) * topLeft.lat +
                    u * (1 - v) * topRight.lat +
                    (1 - u) * v * bottomLeft.lat +
                    u * v * bottomRight.lat,
                lng:
                    (1 - u) * (1 - v) * topLeft.lng +
                    u * (1 - v) * topRight.lng +
                    (1 - u) * v * bottomLeft.lng +
                    u * v * bottomRight.lng,
            };
        }

        // Iterative Newton-Raphson solver for (u, v)
        let u = 0.5;
        let v = 0.5;
        const MAX_ITER = 20;
        const EPSILON = 1e-10;

        for (let i = 0; i < MAX_ITER; i++) {
            const p = bilinearPoint(u, v);
            const dLat = lat - p.lat;
            const dLng = lng - p.lng;

            if (Math.abs(dLat) < EPSILON && Math.abs(dLng) < EPSILON) break;

            // Partial derivatives of bilinear mapping
            // dP/du
            const dpdu_lat =
                -(1 - v) * topLeft.lat +
                (1 - v) * topRight.lat -
                v * bottomLeft.lat +
                v * bottomRight.lat;
            const dpdu_lng =
                -(1 - v) * topLeft.lng +
                (1 - v) * topRight.lng -
                v * bottomLeft.lng +
                v * bottomRight.lng;

            // dP/dv
            const dpdv_lat =
                -(1 - u) * topLeft.lat -
                u * topRight.lat +
                (1 - u) * bottomLeft.lat +
                u * bottomRight.lat;
            const dpdv_lng =
                -(1 - u) * topLeft.lng -
                u * topRight.lng +
                (1 - u) * bottomLeft.lng +
                u * bottomRight.lng;

            // Jacobian determinant
            const det = dpdu_lat * dpdv_lng - dpdu_lng * dpdv_lat;
            if (Math.abs(det) < 1e-14) break; // Singular, bail out

            // Newton step (J^-1 * residual)
            u += (dpdv_lng * dLat - dpdv_lat * dLng) / det;
            v += (-dpdu_lng * dLat + dpdu_lat * dLng) / det;
        }

        // Clamp and check bounds
        const TOLERANCE = 0.001;
        if (u < -TOLERANCE || u > 1 + TOLERANCE || v < -TOLERANCE || v > 1 + TOLERANCE) {
            return null; // Point is outside the image
        }

        let returnObject = {
            x: Math.round(Math.min(Math.max(u, 0), 1) * imageWidth),
            y: Math.round(Math.min(Math.max(v, 0), 1) * imageHeight),
        };

        if(returnObject.x == null){
            returnObject.x = 0;
        }

        if(returnObject.y == null){
            returnObject.y = 0;
        }

        return returnObject;
    },
    getDistance(lat1, lon1, lat2, lon2, unit = 'K') {
        // Convert degrees to radians
        const radLat1 = (Math.PI * lat1) / 180;
        const radLat2 = (Math.PI * lat2) / 180;
        
        const deltaLat = (Math.PI * (lat2 - lat1)) / 180;
        const deltaLon = (Math.PI * (lon2 - lon1)) / 180;

        // Haversine formula calculation
        const a = Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
                Math.cos(radLat1) * Math.cos(radLat2) *
                Math.sin(deltaLon / 2) * Math.sin(deltaLon / 2);
                
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        // Define Earth's radius based on preferred unit
        const R = (unit === 'M') ? 3958.8 : 6371; // M = Miles, K = Kilometers

        return R * c;
    },
    generateRandomHex(){
        const randomHexColor = `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`;
        return randomHexColor;
    }
};

export default mapUtility;
